import React from 'react';

function BusinessInfoStep({ businessInfo, onChange, validationErrors }) {
  return (
    <div className="space-y-4 border-t border-gray-200 dark:border-gray-800 pt-6">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-bold text-gray-900 dark:text-white">기업정보</h3>
        <span className="text-xs text-primary-strong font-bold">* 필수입력사항</span>
      </div>

      <div className="group">
        <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 mb-1.5">사업자등록번호 *</label>
        <input
          type="text"
          name="businessInfo.businessNumber"
          value={businessInfo.businessNumber}
          onChange={onChange}
          className={`w-full bg-gray-50 dark:bg-[#0d1b12] border ${validationErrors.businessNumber ? 'border-red-500' : 'border-gray-200 dark:border-[#1d3324]'} text-gray-900 dark:text-white text-sm rounded-xl px-4 py-3.5 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all`}
          placeholder="000-00-00000"
          maxLength="12"
        />
        {validationErrors.businessNumber && <p className="text-red-500 text-xs mt-1.5 font-medium">{validationErrors.businessNumber}</p>}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="group">
          <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 mb-1.5">회사(법인)명 *</label>
          <input
            type="text"
            name="businessInfo.companyName"
            value={businessInfo.companyName}
            onChange={onChange}
            className={`w-full bg-gray-50 dark:bg-[#0d1b12] border ${validationErrors.companyName ? 'border-red-500' : 'border-gray-200 dark:border-[#1d3324]'} text-gray-900 dark:text-white text-sm rounded-xl px-4 py-3.5 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all`}
            placeholder="회사명 입력"
          />
          {validationErrors.companyName && <p className="text-red-500 text-xs mt-1.5 font-medium">{validationErrors.companyName}</p>}
        </div>
        <div className="group">
          <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 mb-1.5">대표자명 *</label>
          <input
            type="text"
            name="businessInfo.ceoName"
            value={businessInfo.ceoName}
            onChange={onChange}
            className={`w-full bg-gray-50 dark:bg-[#0d1b12] border ${validationErrors.ceoName ? 'border-red-500' : 'border-gray-200 dark:border-[#1d3324]'} text-gray-900 dark:text-white text-sm rounded-xl px-4 py-3.5 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all`}
            placeholder="대표자명 입력"
          />
          {validationErrors.ceoName && <p className="text-red-500 text-xs mt-1.5 font-medium">{validationErrors.ceoName}</p>}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="group">
          <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 mb-1.5">종목</label>
          <input
            type="text"
            name="businessInfo.businessType"
            value={businessInfo.businessType}
            onChange={onChange}
            className="w-full bg-gray-50 dark:bg-[#0d1b12] border border-gray-200 dark:border-[#1d3324] text-gray-900 dark:text-white text-sm rounded-xl px-4 py-3.5 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
            placeholder="예: 서비스업"
          />
        </div>
        <div className="group">
          <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 mb-1.5">업태</label>
          <input
            type="text"
            name="businessInfo.businessCategory"
            value={businessInfo.businessCategory}
            onChange={onChange}
            className="w-full bg-gray-50 dark:bg-[#0d1b12] border border-gray-200 dark:border-[#1d3324] text-gray-900 dark:text-white text-sm rounded-xl px-4 py-3.5 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
            placeholder="예: 소매업"
          />
        </div>
      </div>

      <div className="group">
        <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 mb-1.5">사업장 소재지</label>
        <input
          type="text"
          name="businessInfo.businessAddress"
          value={businessInfo.businessAddress}
          onChange={onChange}
          className="w-full bg-gray-50 dark:bg-[#0d1b12] border border-gray-200 dark:border-[#1d3324] text-gray-900 dark:text-white text-sm rounded-xl px-4 py-3.5 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
          placeholder="사업장 주소 입력"
        />
      </div>

      <div className="group">
        <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 mb-1.5">세금계산서 발행 이메일</label>
        <input
          type="email"
          name="businessInfo.taxInvoiceEmail"
          value={businessInfo.taxInvoiceEmail}
          onChange={onChange}
          className="w-full bg-gray-50 dark:bg-[#0d1b12] border border-gray-200 dark:border-[#1d3324] text-gray-900 dark:text-white text-sm rounded-xl px-4 py-3.5 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
          placeholder="tax@company.com"
        />
      </div>
    </div>
  );
}

export default BusinessInfoStep;
